import LegalDisclaimer from './LegalDisclaimer';
import ResourcesModule from './ResourcesModule';
import OverviewModule from './OverviewModule';
import NotificationBanner from './NotificationBanner';
import { PolicyModule } from './RentGuaranteeManagePolicyResponse';

const RentalProtectionManagePoliciesResponse = ({
  listingState = '',
  header = '',
  title = '',
  policyModules = [],
  resourcesModule = {},
  overviewModule = {},
  legalDisclaimer = {},
  notificationBanner = {},
} = {}) => ({
  listingState: String(listingState),
  header: String(header),
  title: String(title),
  policyModules: policyModules.map((policyModule) => PolicyModule(policyModule)),
  resourcesModule: ResourcesModule(resourcesModule),
  overviewModule: OverviewModule(overviewModule),
  legalDisclaimer: LegalDisclaimer(legalDisclaimer),
  notificationBanner: NotificationBanner(notificationBanner),
});

export default RentalProtectionManagePoliciesResponse;

export type RentalProtectionManagePoliciesResponseType = ReturnType<typeof RentalProtectionManagePoliciesResponse>;
